import React from 'react'
import { Box, Stepper as BaseStepper, Text } from '@workwhile/ui'
import { useBulkCreateShiftsContextValue } from '../../context/BulkCreateShiftsProvider'
import styles from './Stepper.module.css'

const hasRouteState = (
  route: ReturnType<
    typeof useBulkCreateShiftsContextValue
  >['state']['allRoutes'][number]
): route is ReturnType<
  typeof useBulkCreateShiftsContextValue
>['state']['allRoutes'][number] & {
  state: { title: string }
} => {
  return (
    typeof route.state === 'object' &&
    route.state !== null &&
    'title' in route.state
  )
}

export const Stepper = () => {
  const {
    state: { activeIndex, allRoutes },
  } = useBulkCreateShiftsContextValue()

  const steps = allRoutes.map((route) => {
    const label = hasRouteState(route) ? route.state?.title : route.path
    return {
      name: route.path,
      title: label,
      path: route.path,
    }
  })

  const activeStep = allRoutes[activeIndex]

  return (
    <Box width={[1, 1, '70rem']} mx="auto" className={styles.stepper}>
      <BaseStepper
        steps={steps}
        currentStep={activeStep.path}
        renderStep={(step) => {
          return <Text>{step.title}</Text>
        }}
      />
    </Box>
  )
}
